// ------------------------------------
// props 輸入需求 :
// props.data1 : object : { data: array }            ( residnet info )
// props.leave : boolean                             ( true : discharge table / false : hospitaliation table )
// ------------------------------------


import React, { useEffect, useState } from 'react'
import ResidentName from './ResidentName';
import HistoryRecord from '../historyRecord/HistoryRecord'
import { useTranslation } from 'react-i18next';
import ResidentUser from './ResidentUser';
import '../_Resident.scss'
import ResidentMacAlert from './ResidnetMacAlert';
import ResidentSetting from '../ResidentSetting';
import ApiGo from '../../../actions/ApiGo';
import { useDispatch, useSelector } from 'react-redux';
import { ADD_RESIDENTS_ARRAY } from '../../../stores/reducer_residentsArray';
import { ADD_RESPONSE, ADD_RESPONSE_JSON } from '../../../stores/reducer_add';
import PopConfirm, { PopConfirm_ReAssignPad } from '../../popUp/PopConfirm';
import AssignResidentPad from '../../pad/Assign/AssignResidentPad';
import Mos from '../../../actions/Mos';
import ApiGo_TS from '../../../actions/ApiGo_TS';

const ResidentRow = (props) => {
    // props 傳入區
    const mos = Mos()
    let p = props.data
    const { t } = useTranslation();
    // 彈出視窗 -2 -- 開啟歷史紀錄
    const [historyPanel, setHistoryPanel] = useState(false);
    function toggleHisPanel() { setHistoryPanel(!historyPanel) }

    const [editPanel, setEditPanel] = useState(false);
    function toggleEditPanel() { setEditPanel(!editPanel) }

    // pop 確認視窗
    const [popDisCharge, setPopDisCharge] = useState({
        open: false,
        content: "",
        parameter: []
    });
    function togglePopDischarge() {
        setPopDisCharge({
            open: false,
            content: "",
            parameter: []
        })
    }
    const [pop, setPop] = useState({
        open: false,
        content: "",
        parameter: []
    });
    function togglePop() {
        setPop({
            open: false,
            content: "",
            parameter: []
        })
    }
    // pop 確認視窗
    const [activateRedux, setActivateRedux] = useState(false);
    function toggleRefresh() { setActivateRedux(!activateRedux) }
    // --------------- redux ---------------
    const store_pad = useSelector(state => state.store_beds.beds_array).filter(mac => mac.mac === p.mac)[0]
    const dispatch = useDispatch()
    useEffect(() => {
        if (activateRedux) {
            ApiGo.getResidents().then(res => { dispatch(ADD_RESIDENTS_ARRAY(res)) })
                .catch(err => { console.log(err); })
            setActivateRedux(false)
        }
    }, [activateRedux]);
    // --------------- redux ---------------

    const [assignResOpen, setAssignResOpen] = useState(false);
    function toggleAssignRes() {
        if (store_pad !== undefined)
            setAssignResOpen(!assignResOpen)
    }
    const handleDischarge = async (mac, id) => {
        setActivateRedux(false);
        await discharged(mac, id, dispatch, mos);
        setActivateRedux(true);
    };

    const handleDelete = async (mac, id) => {
        setActivateRedux(false);
        await deleteResident(mac, id, dispatch, mos);
        setActivateRedux(true);
    };

    return (
        <div className="residents-row-body">
            {assignResOpen ? <AssignResidentPad data={store_pad} hide={toggleAssignRes} toggleRefresh={toggleRefresh} /> : null}
            {pop.open ?
                <PopConfirm
                    title={t("POP_UP.Delete_user_title")}
                    content={pop.content}
                    hide={togglePop}
                    callBack={handleDelete}
                    parameter={pop.parameter}
                />
                : null
            }
            {popDisCharge.open ?
                store_pad !== undefined ?
                    <PopConfirm_ReAssignPad
                        title={p.first_name + " " + p.last_name + t('RESIDENTS.DISCHARGED')}
                        content={popDisCharge.content}
                        hide={togglePopDischarge}
                        callBack1={handleDischarge}
                        callBack2={toggleAssignRes}
                        parameter={popDisCharge.parameter}
                    />
                    : <PopConfirm
                        title={p.first_name + " " + p.last_name + t('RESIDENTS.DISCHARGED')}
                        content={popDisCharge.content}
                        hide={togglePopDischarge}
                        callBack={handleDischarge}
                        parameter={popDisCharge.parameter}
                    />
                : null
            }
            {/* {popDisCharge.open?
                <PopConfirm
                    title={"受護者出院"}
                    content={popDisCharge.content}
                    hide={togglePopDischarge}
                    callBack={discharged}
                    parameter={popDisCharge.parameter}
                    />
                :null
            } */}
            {/* 彈出視窗歷史紀錄 */}
            {editPanel ? <ResidentSetting hide={toggleEditPanel} data={p} page={0} /> : null}
            {historyPanel ? <HistoryRecord hide={toggleHisPanel} data={p} /> : null}

            <div className='d-flex'>

                {/* 床號 */}
                <div className="flex-grow-1 body-container" style={{ minWidth: 0 }}>
                    <div className="body" style={{ display: "block", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                        {p.first_name}
                    </div>
                </div>

                {/* 姓名及歷史查看 */}
                <ResidentName
                    last_name={p.last_name}
                    toggleHisPanel={toggleHisPanel}
                />
                {/* 智慧墊 */}
                <div className="flex-grow-1 body-container"><div className="w-auto min-0 font-l">{(p.mac === null) ? "-" : p.mac}</div></div>

                {/* 照護者 */}
                <ResidentUser userData={props.userData} />

                {/* 照護項目 */}
                <ResidentMacAlert macData={props.macData} />

                {/* 功能 */}
                <div className="flex-grow-2 body-container">
                    <div className="body">
                        <div className="button" onClick={toggleEditPanel}>{t('RESIDENTS.EDIT')}</div>
                        {!props.leave ?          // props.leave ===false (不出院)
                            <div className="button" onClick={() => {
                                setPopDisCharge({
                                    open: true,
                                    content: p.first_name + " " + p.last_name + t('POP_UP.Sure_to_discharge'),
                                    parameter: [p.mac, p.id]
                                })
                            }}>{t('RESIDENTS.DISCHARGED')}</div>
                            : null}
                        <div className="button" onClick={() => {
                            setPop({
                                open: true,
                                content: t('POP_UP.Delete_user_confirm') + p.first_name + " " + p.last_name + "？",
                                parameter: [p.mac, p.id]
                            })
                        }}>{t('RESIDENTS.DELETE')}</div>
                    </div>
                </div>
            </div>
        </div>
    );

}
export default ResidentRow;

// 智能墊解除綁定
const unbindSmartPad = async (mac) => {
    if (mac) {
        await ApiGo.deleteSmart_pad(mac);
    }
};

const finishOperation = (type, dispatch, mos) => {
    dispatch(ADD_RESPONSE({ status: 200, statusText: "success", type }));
    mos.sendPayload('line_notify/resetResident', 'reset');
};

const handleApiError = (err, type, dispatch) => {
    console.error(`Error in ${type}:`, err);
    dispatch(ADD_RESPONSE({ status: err.status || 500, statusText: err.statusText || 'Internal Server Error', type }));
    return err.response;
};

// 出院函數
export async function discharged(mac, id, dispatch, mos) {
    try {
        await unbindSmartPad(mac);
        await ApiGo.deleteHospital(id);
        await ApiGo_TS.deleteResidentAssignId(id, true);
        finishOperation("leave_hos", dispatch, mos);
    } catch (err) {
        handleApiError(err, "leave_hos", dispatch);
    }
}

// 刪除受護者函數
export async function deleteResident(mac, id, dispatch, mos) {
    try {
        await unbindSmartPad(mac);
        await ApiGo_TS.deleteResidentAssignId(id, false);
        await ApiGo.deleteResident_info(id);
        finishOperation("delete_resident", dispatch, mos);
    } catch (err) {
        handleApiError(err, "delete_resident", dispatch);
    }
}
